// import { useSelector } from 'react-redux';
import { IconButton } from '@mui/material';
import { Add, DeleteForever } from '@mui/icons-material';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
// import BaseSelect from '@/components/ui/Select/BaseSelect';

export default function Reference({ form: { control, errors }, i, type = 'add', onClick }) {
	// const refTypes = useSelector((state) => state.content.refTypes);

	const isAdd = type === 'add';
	const ariaLbl = isAdd ? 'add' : 'remove';
	return (
		<div className='grid items-center grid-cols-7 gap-4'>
			{/* <BaseSelect
				control={control}
				name={`reference.${i}.reference_id`}
				label='Referansenummer'
				errors
				data={refTypes}
				config={{
					styles: {},
					classes: '!min-w-min !col-span-3',
					disabled: false,
					optionLabel: '--Søk i referansenummer her--',
					keyVal: 'reference_id',
					keyName: 'reference',
					keyLabel: 'reference',
				}}
				size='small'
			/> */}
			<BaseInputValidation
				control={control}
				name={`reference.${i}.reference_type`}
				label=''
				errors={errors}
				config={{ classes: '!col-span-3' }}
				placeholder='Artikkeltype'
			/>
			<BaseInputValidation
				control={control}
				name={`reference.${i}.reference_detail`}
				label=''
				errors={errors}
				config={{ classes: '!col-span-3' }}
				placeholder='Artikkelnummer'
			/>

			<IconButton
				className='border !bg-primary !text-white !rounded-sm w-10'
				color=''
				aria-label={`${ariaLbl} referansenummer`}
				title={`${ariaLbl} referansenummer`}
				onClick={onClick}
				type='button'
			>
				{isAdd ? <Add /> : <DeleteForever />}
			</IconButton>
		</div>
	);
}
